import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import TenantThemeProvider from "./components/TenantThemeProvider";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <TenantThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </TenantThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
